'use client';
import React__default, { useRef, useEffect } from 'react';
import { IconX } from '../Icons/Status/X.js';

const Modal = _ref => {
  let {
    active,
    close,
    children,
    className = ''
  } = _ref;
  const dialogRef = useRef(null);
  const {
    position = 'right',
    location = 'inside',
    buttonEnabled = true,
    callback: onClose = () => null,
    component: CloseComponent = IconX
  } = close || {};
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (active) {
      if (!dialog.open) dialog.showModal();
      document.body.style.overflow = 'hidden';
    } else {
      if (dialog.open) dialog.close();
      document.body.style.overflow = '';
    }
    dialog.addEventListener('cancel', onClose);
    const handleClickOutside = event => {
      if (active && onClose && event.target === dialog) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      dialog.removeEventListener('cancel', onClose);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [active, onClose]);
  return /*#__PURE__*/React__default.createElement("dialog", {
    className: `b-modal  ${className}`,
    ref: dialogRef,
    "data-testid": "modal",
    "aria-modal": active,
    "aria-hidden": !active
  }, buttonEnabled && onClose && /*#__PURE__*/React__default.createElement("button", {
    className: `b-modal__close b-modal__close--${position} b-modal__close--${location}`,
    onClick: onClose,
    "aria-label": "Close"
  }, CloseComponent && /*#__PURE__*/React__default.createElement(CloseComponent, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "b-modal__scroll-container"
  }, children));
};
Modal.displayName = 'Modal';

export { Modal };
